export default "__VITE_ASSET__BP_mh5l1__"